// Trade times are stored in GMT; these render them in the viewer's own time zone (24-hour clock).

const pad = (n) => String(n).padStart(2, '0');

/** Parses the backend's GMT "MM/DD/YYYY HH:mm:ss" string; returns null if it isn't in that shape. */
export const parseGmtTradeTime = (value) => {
  const m = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/.exec(String(value ?? '').trim());
  if (!m) return null;
  const [, mo, d, y, h, mi, s] = m.map(Number);
  return new Date(Date.UTC(y, mo - 1, d, h, mi, s));
};

/** Epoch ms (or Date) → local "HH:mm:ss". */
export const formatLocalTime = (value) => {
  const date = value instanceof Date ? value : new Date(Number(value));
  if (Number.isNaN(date.getTime())) return '';
  return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

/** GMT "MM/DD/YYYY HH:mm:ss" → local "MM/DD/YYYY HH:mm:ss"; unparseable values pass through unchanged. */
export const formatLocalTradeDateTime = (value) => {
  const date = parseGmtTradeTime(value);
  if (!date) return value;
  return `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()} ${formatLocalTime(date)}`;
};
